/* file description */

import { useCallback, useRef, useState } from 'react';
import { Modal } from 'antd';
import { COLUMN_FROM } from '../../../effects/consts';
import { getModuleRecordList } from '@/common/asset-apis/assetModel'
import { OnLinkShowModalTableSelect, OnRecordSelectLinkShowModalEnter, SetShowFieldsValue, UseLinShowModalSelect } from './type';

export const useLinShowModalSelect: UseLinShowModalSelect = ({ setShowLabel, API, isMulti, setOptionList, moduleInfo, SelectedRef }) => {
  // 弹窗展示控制
  const [showLinkShowModal, linkShowModalContrulor] = useState(false);
  // 选中控制
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  // 选择后的回调处理
  const onSelectChange = useCallback<OnLinkShowModalTableSelect>(
    (_selectedIDList: React.Key[], selectedRecordList: Array<Record<any, any>>) => {
      setSelectedRowKeys(_selectedIDList)
      if (isMulti) {
        SelectedRef.current = selectedRecordList || null;
      } else {
        SelectedRef.current = selectedRecordList[0] || null;
      }
    },
    [SelectedRef.current],
  );

  // 单击行时处理
  const clickRow = (key: any, record: any) => {
    if (isMulti) {
      const keysList = [...selectedRowKeys]
      if (keysList.indexOf(key) >= 0) {
        keysList.splice(keysList.indexOf(key), 1)
      } else {
        keysList.push(key)
      }
      setSelectedRowKeys(keysList)
    } else {
      SelectedRef.current = record
      setSelectedRowKeys([key])
    }
  }

  // 联动字段更新
  const setShowFieldsValue: SetShowFieldsValue = (form, field, columnFrom, config, type) => {
    if (isMulti) {
      return
    }
    const { emitEvent } = config.metaStore || {};
    const { showFields = [], options = [] } = field.options || {};
    // 联动展示字段
    // showFields.forEach((item: { key: any; realLabel: any; showModule: any; showModuleLabel: any; showModuleValue?: string }) => {
    //   const values: Record<any,any> = {}
    //   const setName = `${field.name}_LINK_${item?.key}`
    //   if (columnFrom === COLUMN_FROM.FORM) {
    //     if (item?.showModule && item?.showModuleLabel) {
    //       getModuleRecordListCache(
    //         API.FetchAPI,
    //         'master_data', // 引用关系从主数据中查找
    //         item?.showModule,
    //         {
    //           moduleID: item?.showModule,
    //           namespaceID: 'master_data',
    //           limit: 100,
    //           filter: `${item?.showModuleValue} = '${SelectedRef.current?.[item?.key]}'`,
    //         },
    //       ).then((res: any) => {
    //         const recordValues = res.set?.[0]?.values || [];
    //         const resultLabel = recordValues.find((json: any) => json.name === item?.showModuleLabel)?.value || SelectedRef.current![item?.key];
    //         values[setName] = type === 'reset' ? '' : resultLabel;
    //         form.setFieldsValue(values);
    //       });
    //     } else {
    //       values[setName] = type === 'reset' ? '' : SelectedRef.current![item?.key]
    //       form.setFieldsValue(values)
    //     }
    //   }
    //   if (columnFrom === COLUMN_FROM.TABLE) {
    //     if (item?.showModule && item?.showModuleLabel) {

    //     } else {
    //       const tableKey = config.rowIndex
    //       values[tableKey] = {}
    //       values[tableKey][setName] = type === 'reset' ? '' : SelectedRef.current![item?.key]
    //       form.setFieldsValue(values)
    //     }
    //   }
    // })
    // 联动保存字段
    options.forEach((item: { moduleField: any; linkField: any }) => {
      const values: Record<any, any> = {}
      if (columnFrom === COLUMN_FROM.FORM) {
        values[item.moduleField] = type === 'reset' ? '' : SelectedRef.current![item.linkField]
        form.setFieldsValue(values)
      }
      if (columnFrom === COLUMN_FROM.TABLE) {
        const tableKey = config.rowIndex
        values[tableKey] = {}
        values[tableKey][item.moduleField] = type === 'reset' ? '' : SelectedRef.current![item.linkField]
        form.setFieldsValue(values)
      }
      emitEvent && emitEvent({ value: SelectedRef.current![item.linkField], moduleName: moduleInfo.handle, fieldName: item.moduleField, rowIndex: config.rowIndex, touchConfig: 'change' });
    })
  }

  const setInputLabel = async (field: any, initLabel: string, initValue: string) => {
    const { labelBindLabel, isBindLabel, value, dataKey, label, treeId, bindId, labelModule, labelBindKey } = field.options || {};
    const option: Record<any, any> = {}
    // 子表联动显示字段获取
    if (isBindLabel) {
      try {
        const res = await getModuleRecordList(
          API.FetchAPI,
          treeId,
          dataKey,
          {
            moduleID: dataKey,
            namespaceID: treeId,
            limit: 100,
            filter: `${value} = '${initValue}'`,
          },
        );
        const recordValues = res.set?.[0]?.values || [];
        recordValues.forEach((item: any) => {
          if (item.name === label) {
            getModuleRecordList(
              API.FetchAPI,
              bindId || treeId,
              labelModule,
              {
                moduleID: labelModule,
                namespaceID: bindId || treeId,
                limit: 100,
                filter: `${labelBindKey} = '${item.value}'`,
              },
            ).then(response => {
              const bindRecordValues = response.set?.[0]?.values || [];
              bindRecordValues.forEach((item: any) => {
                if (item.name === labelBindLabel) {
                  option[field?.options?.labelBindLabel] = item.value;
                  option[field?.options?.value] = initValue;
                  setOptionList([option]);
                  // setShowLabel(item.value)
                }
              });
            });
          }
        });
      } catch {
        option[field?.options?.labelBindLabel] = initValue
        option[field?.options?.value] = initValue
        setOptionList([option])
        // setShowLabel(initValue)
      }
    } else {
      option[field?.options?.label] = initLabel || initValue
      option[field?.options?.value] = initValue
      setOptionList([option])
      // setShowLabel(initLabel || initValue)
    }
  }

  // 弹窗确认按钮被点击后的处理
  const onModalEnter = useCallback<OnRecordSelectLinkShowModalEnter>(({ onChange, fieldName, form, field, columnFrom, config }) => {
    if (!SelectedRef.current) {
      // Modal.confirm({
      //   zIndex: 5000,
      //   content: '您未选择任何一项，这将会将其设为空，确认此操作吗?',
      //   onOk: () => {
      //     // TODO 联动更新
      //     setShowFieldsValue(form, field, columnFrom, config, 'reset')
      //     onChange && onChange(null);
      //     // setShowLabel('')
      //     linkShowModalContrulor(false);
      //   },
      // });
      linkShowModalContrulor(false);
      return;
    }
    if (isMulti) {
      const multiArr: any[] = [];
      const multiLabel: any[] = [];
      SelectedRef.current.forEach((item: Record<string, any>) => {
        multiArr.push(item[fieldName]);
        multiLabel.push(item[field?.options?.label] || item[field?.options?.value]);
      });
      setOptionList(SelectedRef.current);
      onChange && onChange(multiArr);
      // setShowLabel(multiLabel.join())
    } else {
      if (field?.options?.isBindLabel) {
        setInputLabel(field, SelectedRef.current[fieldName], SelectedRef.current[fieldName]);
      } else {
        setOptionList([SelectedRef.current]);
      }
      // 选择时给联动字段赋值
      // setShowFieldsValue(form, field, columnFrom, config)
      onChange && onChange(SelectedRef.current[fieldName]);
      // 选择后回填INPUT框
      // setInputLabel(field, SelectedRef.current[field?.options?.label], SelectedRef.current[field?.options?.value])
    }
    linkShowModalContrulor(false);
  }, []);

  return {
    showLinkShowModal,
    onSelectChange,
    onModalEnter,
    linkShowModalContrulor,
    setInputLabel,
    clickRow,
    selectedRowKeys,
    setSelectedRowKeys,
  };
};
